export var convertTextToId = function convertTextToId() {
  var headline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return headline.replace(/\r?\n|\r/g, '').replace(/\s+/g, '-').toLowerCase();
};